
import Vue from "vue";
import RespressoApi from "../../../api/respresso-api";
import ErrorHandler from "../../../services/error-handler";
import {teamModule} from "../../../store/modules/team";
import LoadingService from "../../../services/loading-service";
import UserService from "../../../services/user-service";
import {CreateProjectRequest} from "respresso";
import {translate} from "../../../main";

export default Vue.extend({
  name: "team-and-project-target-picker",
  components: {},
  props: {
    team: {
      type: Object,
      default: () => teamModule.team
    },
    createLabel: {
      type: String,
      default: () => translate("buttons.createProject")
    }
  },
  data() {
    return {
      projectName: "" as string,
      error: "" as string,
      minLength: 1 as number,
    }
  },
  methods: {
    createProject: async function() {
      if (this.projectName && this.projectName.length >= this.minLength) {
        await LoadingService.waitForPromise(this.executeProjectCreation(this.projectName))
      } else {
        this.error = "You must name your project"
      }
    },
    executeProjectCreation: async function(name: string) {
      const data: CreateProjectRequest = {
        title: this.projectName,
        name: this.projectName,
        users: [], // Not available currently
      };
      const resp = await ErrorHandler.tryRequest(() => RespressoApi.createProject(this.team!.id, data));
      if (resp) {
        await UserService.loadTeam(teamModule.team!.id);
        this.emitProjectCreated(resp.projectId);
      }
    },
    emitProjectCreated: function(projectId: string) {
      this.$emit("project-created", projectId);
    },
    emitCancel: function() {
      this.$emit("cancelled", true);
    },
  }
})

